import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import * as moment from 'moment';
import { ancestorWhere } from 'tslint';
import { DefinitionsService } from '../../../../../../app.common/modules/common/services/definitions.service';
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { IFindShopperByEmailRequest } from '../../../../model/IFindShopperByEmailRequest';
import { IShopperStaffDiscountCreate } from '../../../../model/IShopperStaffDiscountCreate';
import { DiscountForStaffService } from '../../../discount-for-staff.service';

class AddOrEditStaff implements ng.IController {
    public static $inject = [
        '$translate',
        'definitionsService',
        'notificationService',
        'discountForStaffService'
    ];
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    public waiting: boolean;

    public emailPattern: RegExp = this.definitionsService.regexEmail;

    public model = {
        dialogTitle: '',
        email: '',
        staffID: null,
        firstName: '',
        lastName: '',
        date: null,
        canEdit: false,
        clickSearch: false,
        isSuccessSearch: true,
        isAlreadyExist: false,
        isEditMode: false
    };

    public dateOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        minDate: new Date()
    };

    public resolve: {
        discountID: number;
    };

    public requiredDateError = false;

    constructor(
        private $translate: angular.translate.ITranslateService,
        public definitionsService: DefinitionsService,
        private notificationService: NotificationService,
        private discountForStaffService: DiscountForStaffService
    ) {}

    public async $onInit() {
        if (this.resolve.discountID) {
            this.model.isEditMode = true;
            this.model.canEdit = false;
            await this.findStaff(this.model.isEditMode);
        }
    }

    public clearEmailAndReset() {
        this.model.email = null;
        this.model.canEdit = false;
        this.model.firstName = null;
        this.model.lastName = null;
        this.model.date = null;
        this.model.clickSearch = false;
        this.model.isSuccessSearch = true;
        this.model.isAlreadyExist = false;
    }

    public resetErrors() {
        this.model.isSuccessSearch = true;
        this.model.isAlreadyExist = false;
        this.model.clickSearch = false;
    }

    public getSearchClass() {
        return this.model.email ? 'fa-search--active' : '';
    }

    public async findStaff(isEditMode: boolean) {
        this.waiting = true;
        this.model.clickSearch = true;
        try {
            isEditMode
                ? await this.loadAndSetStaffByID()
                : await this.loadAndSetStaffByEmail();
            this.model.isSuccessSearch = true;
            this.model.canEdit = true;
        } catch (error) {
            this.model.isSuccessSearch = false;
            this.model.canEdit = false;
        } finally {
            this.waiting = false;
            this.notificationService.clearAll();
        }
    }

    public async addOrEditStaff() {
        if (!this.model.date) {
            this.requiredDateError = true;
            return;
        }
        try {
            const query: IShopperStaffDiscountCreate = {
                ShopperID: this.model.staffID,
                FirstName: this.model.firstName,
                LastName: this.model.lastName,
                DiscountExpirationDate: moment(this.model.date).utc(true).startOf('day').toDate()
            };
            if (this.model.isEditMode) {
                await this.discountForStaffService.editStaff(
                    this.model.staffID,
                    query
                );
            } else {
                await this.discountForStaffService.createStaff(query);
            }
            this.notificationService.showSuccessMessage();
            this.modalInstance.close({ $value: 'ok' });
        } catch (error) {
            error.includes('Discount for employe already exist')
                ? (this.model.isAlreadyExist = true)
                : this.notificationService.showErrorMessage(error);
        } finally {
            this.notificationService.clearAll();
            this.requiredDateError = false;
        }
    }

    public close() {
        this.modalInstance.close();
    }

    private async loadAndSetStaffByEmail() {
        const query: IFindShopperByEmailRequest = {
            Email: this.model.email
        };
        const staff = await this.discountForStaffService.findStaffByEmail(
            query
        );
        this.model.firstName = staff.FirstName;
        this.model.lastName = staff.LastName;
        this.model.staffID = staff.ID;
    }

    private async loadAndSetStaffByID() {
        const staff = await this.discountForStaffService.getStaff(
            this.resolve.discountID
        );
        this.model.firstName = staff.FirstName;
        this.model.lastName = staff.LastName;
        this.model.date = new Date(staff.DiscountExpirationDate);
        this.model.email = staff.Email;
        this.model.staffID = this.resolve.discountID;
    }
}

angular.module('naut').component('addOrEditStaff', {
    template: require('./add-or-edit-staff.component.html'),
    controller: AddOrEditStaff,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/special-tab/active-tab/add-or-edit-staff/add-or-edit-staff.component.ts